// Хранилище недавно просмотренных товаров (localStorage, most-recent-first).
// Используется для блока «Вы смотрели» в каталоге и дедупа трекинга просмотров.

const KEY = "recently_viewed";
const CAP = 20;

// ID, чьи просмотры уже засчитаны в текущей загрузке приложения (дедуп инкремента).
const _viewedThisSession = new Set<number>();

export function getRecentlyViewedIds(): number[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "number") : [];
  } catch {
    return [];
  }
}

export function addRecentlyViewed(id: number): void {
  const next = [id, ...getRecentlyViewedIds().filter((x) => x !== id)].slice(0, CAP);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* приватный режим / переполнение — игнорируем */
  }
}

/** true — если просмотр этого товара ещё не засчитан в этой сессии приложения. */
export function shouldCountView(id: number): boolean {
  if (_viewedThisSession.has(id)) return false;
  _viewedThisSession.add(id);
  return true;
}
